import { Theme } from '@mui/material/styles';

// ==============================|| CUSTOM FUNCTION - COLORS ||============================== //

export default function getColors(theme: Theme, color: string) {
  const vars = theme.vars!.palette;
  switch (color) {
    case 'secondary':
      return vars.secondary;
    case 'error':
      return vars.error;
    case 'warning':
      return vars.warning;
    case 'info':
      return vars.info;
    case 'success':
      return vars.success;
    default:
      return vars.primary;
  }
}
